var $573c338a19d2e44a$exports = {};
$573c338a19d2e44a$exports = {
    "loading": `Cargando\u{2026}`,
    "placeholder": `Seleccione\u{2026}`
};


export {$573c338a19d2e44a$exports as default};
//# sourceMappingURL=es-ES.module.js.map
